import React, { Component, Fragment } from 'react'
import { Input, Pagination } from 'antd'
import { Link } from 'react-router-dom'
import numeral from 'numeral'
import SingleView from '../../components/SingleView'
import { drop } from 'lodash'
const { Search } = Input

class PurchaseOrders extends Component {
  constructor(props) {
    super(props)
    this.state = {
      page: 1,
      currentPurchaseOrders: null
    }
  }
  setPage = page => {
    this.setState({
      page
    })
  }
  getData = () => {
    if (this.state.currentPurchaseOrders || this.props.purchaseOrders) {
      return this.state.currentPurchaseOrders
        ? this.state.currentPurchaseOrders
        : this.props.purchaseOrders
    }
    return []
  }
  getPagedData = () => {
    const { page } = this.state
    const data = this.state.currentPurchaseOrders
      ? this.state.currentPurchaseOrders
      : this.props.purchaseOrders
    const offset = (page - 1) * 10
    return drop(data, offset).slice(0, 10)
  }

  searchPurchaseOrder = text => {
    const { purchaseOrders } = this.props
    const filteredPurchaseOrders = purchaseOrders.filter(po => po.id.toString().startsWith(text))
    this.setState({
      currentPurchaseOrders: filteredPurchaseOrders
    })
  }

  render() {
    return (
      <div className="">
        <div className="jobsBar">Purchase Orders</div>
        <Search
          placeholder="Search by number"
          onChange={event => this.searchPurchaseOrder(event.target.value)}
          style={{ marginTop: 10, marginBottom: 10 }}
        />
        <SingleView
          title="Purchase Orders"
          emptyText="No purchase orders for this vendor"
          data={this.getPagedData()}
          getKey={a => a.id}
          getHeader={a => `${a.id} - ${a.description}`}
        >
          {o => (
            <Fragment>
              <div className="row">
                <div className="col-md-3">
                  <div className="jobDetailsHeader">Identification:</div>
                  <span>
                    <Link
                      to={`/jobView/${o.job_id}/${o.job_type}/vendors/purchase-order/modal/${o.id}`}
                    >
                      {o.id}
                    </Link>
                  </span>
                </div>
                <div className="col-md-5">
                  <div className="jobDetailsHeader">Content:</div>
                  <span>{o.description}</span>
                </div>
                <div className="col-md-4">
                  <div className="jobDetailsHeader">Grand Total:</div>
                  <span>{numeral(o.grand_total).format('$0,0.00')}</span>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="jobDetailsHeader">Created by:</div>
                  <span>
                    {o.created_by_first_name} {o.created_by_last_name}
                  </span>
                </div>
                <div className="col-md-6">
                  <div className="jobDetailsHeader">Updated by:</div>
                  <span>
                    {o.updated_by_first_name} {o.updated_by_last_name}
                  </span>
                </div>
              </div>
            </Fragment>
          )}
        </SingleView>
        <Pagination
          total={this.getData().length}
          pageSize={10}
          current={this.state.page}
          defaultCurrent={1}
          onChange={this.setPage}
        />
      </div>
    )
  }
}

export default PurchaseOrders



// WEBPACK FOOTER //
// ./src/components/vendor/PurchaseOrders.js